import React from 'react'
import Fragment from '../common/fragment'


function FragmentBA(props) {
  return (
    <Fragment pos="aa" {...props}>
      <p>
“La gráfica de las acciones de las personas se complica mediante acciones
fallidas” (Brecht). Teatro Ojo construye un Muñeco y lo abandona en los techos de
un Convento, para que el autómata desmesurado vea lo que ellos no pueden
advertir: el interior humeante de las cosas y la danza de las abejas. Actos fallidos,
como prédicas al silencio de la tarde y la discreta distancia del mundo.
      </p>
    </Fragment>
  )
}


export default FragmentBA
